/* eslint-disable @typescript-eslint/no-empty-interface, max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-param-reassign, react/jsx-closing-bracket-location, max-len */
import React, { useMemo, useState } from 'react';
import { Paper, Tooltip } from '@mui/material';
import { Table } from 'src/components';
import { convertApiDataToTable } from 'src/pages/CurrentInterviews/utils';
import { createColumnHelper } from '@tanstack/react-table';
import moment from 'moment';
import { RowHover } from 'src/components/Table';
import { EditIcon } from 'src/icons';
import { PannaInterviewReportView } from 'src/pages/CompletedInterviews/components';
import { confirmWrapper } from 'src/components/Dialog';
import { useClients } from 'src/hooks/query/clients';
import { useRoleUser } from 'src/hooks/query/usersByRole';
import { CurrentInterviewsListTable, CurrentInterviewsListValues, CurrentInterviewsViewRendererProps } from '../../types';
import { CurrentInterviewsFilters } from '../../components';

interface ActionDivProps {
  onAction: (data: CurrentInterviewsListValues) => void;
  info: CurrentInterviewsListValues;
}

const ActionDiv = function addAction(actionProps: ActionDivProps) {
  const { onAction, info } = actionProps;
  const handleIconClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    onAction(info);
  };
  return (
    <div className="flex flex-row justify-center items-center gap-2">
      <Tooltip title="Actions on interview">
        <div onClick={handleIconClick}>
          <EditIcon />
        </div>
      </Tooltip>
    </div>
  );
};

function Desktop(props: CurrentInterviewsViewRendererProps) {
  const {
    currentInterviews,
    currentInterviewsFetching,
    filters,
    onAction,
    onApplyFilter,
    onFiltersReset,
    onChangePagination,
    onUpdateInterviewStatus,
    sendEmail,
  } = props;

  const { clientOptions } = useClients();

  const payload = { roleNameList: 'ATSInterviewer' };
  const { userByRoleOptions } = useRoleUser(payload);

  const clientIdToNameMap = useMemo(() => {
    const map: Record<string, string> = {};
    clientOptions.forEach((client) => {
      map[client.value] = client.label;
    });
    return map;
  }, [clientOptions]);

  const interviewerIdToNameMap = useMemo(() => {
    const map: Record<string, string> = {};
    userByRoleOptions.forEach((interviewer) => {
      map[interviewer.value] = interviewer.label;
    });
    return map;
  }, [userByRoleOptions]);

  const [rowHover, setRowHover] = useState<RowHover>({});
  const columnHelper = createColumnHelper<CurrentInterviewsListTable>();
  const columns = [columnHelper.accessor('createdDate', {
    header: () => <div className="ml-6">Date</div>,
    cell: (info) => (
      <div className="ml-6">
        <div>
          {moment(info.getValue(), 'ddd MMM DD HH:mm:ss [zzz] YYYY').format('MM/DD/YYYY')}
        </div>
      </div>
    ),
  }), columnHelper.accessor('firstName', {
    header: () => <div className="p-2">Name</div>,
    cell: (info) => (
      <Tooltip title={`${info.getValue()} ${info.row.original.lastName ? info.row.original.lastName : ''}`}>
        <div className="px-2 w-[120px] truncate">
          {info.getValue()}
        &nbsp;
          {info.row.original.lastName}
        </div>
      </Tooltip>
    ),
  }), columnHelper.accessor('phoneNumber', {
    header: () => <div className="p-2">Ph.no</div>,
    cell: (info) => (
      <div className="px-2">
        {info.getValue()}
      </div>
    ),
  }), columnHelper.accessor('interviewMode', {
    header: () => <div className="p-2">Type</div>,
    cell: (info) => (
      <Tooltip title={info.getValue()}>
        <div className="px-2 w-[90px] truncate">
          {info.row.original.MLiveInterviewerLink ? (
            <a
              target="_blank"
              href={info.row.original.MLiveInterviewerLink}
              rel="noreferrer"
              className="text-primary"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                window.open(info.row.original.MLiveInterviewerLink, '_blank');
              }}
          >
              {info.getValue()}
            </a>
          ) : (
            <span className="text-primary">{info.getValue()}</span>
          )}
        </div>
      </Tooltip>
    ),
  }), columnHelper.accessor('interviewerId', {
    header: () => <div className="p-2">Interviewer</div>,
    cell: (info) => {
      const interviewerId = info.getValue();
      const displayName = interviewerId ? (interviewerIdToNameMap[interviewerId] || interviewerId) : 'PAÑÑÃ AI';
      return (
        <Tooltip title={displayName}>
          <div className="px-2 w-[110px] truncate">
            {displayName}
          </div>
        </Tooltip>
      );
    },
  }), columnHelper.accessor('interviewId', {
    header: () => <div className="p-2">Interview Date & Time</div>,
    cell: (info) => {
      const displayName = `${info.row.original.interviewDate} ${info.row.original?.timeSlot ? moment(info.row.original?.timeSlot, 'hh:mm A').format('HH:mm:ss') : '00:00:00'}`;
      return (
        <Tooltip title={displayName}>
          <div className="px-2 w-[110px] truncate">
            {info.row.original.interviewDate}
            &nbsp;
            {info.row.original?.timeSlot ? moment(info.row.original?.timeSlot, 'hh:mm A').format('HH:mm:ss') : '00:00:00'}
          </div>
        </Tooltip>
      );
    },
  }), columnHelper.accessor('jobId', {
    header: () => <div className="p-2">Job ID - Title</div>,
    cell: (info) => (
      <Tooltip title={`${info.getValue()}-${info.row.original.jobTitle}`}>
        <div className="px-2 w-[180px] truncate">
          {info.getValue()}
          {' - '}
          {info.row.original.jobTitle}
        </div>
      </Tooltip>
    ),
  }), columnHelper.accessor('clientId', {
    header: () => <div className="p-2">Client</div>,
    cell: (info) => {
      const clientName = clientIdToNameMap[info.getValue()];
      return (
        <Tooltip title={clientName}>
          <div className="px-2 max-w-[200px] truncate">
            {clientName}
          </div>
        </Tooltip>
      );
    },
  }),
  columnHelper.accessor('jobOrderId', {
    header: () => '',
    cell: (info) => (
      <div className="px-2 flex justify-center items-center min-w-[80px] min-h-[40px]">
        {rowHover[info.row.index] && (
          <ActionDiv
            info={info.row.original as CurrentInterviewsListValues}
            onAction={onAction}
          />
        )}
      </div>
    ),
  })];

  const onRowHover = (data: RowHover) => {
    setRowHover(data);
  };
  const onRowClick = async (e: CurrentInterviewsListValues) => {
    console.log(e);
    await confirmWrapper('', {
      variant: '',
      hidePrimaryBtn: true,
      hideSecondaryBtn: true,
      maxWidth: 'md',
      fullWidth: true,
      showCloseButton: true,
      disableBackdropClickClose: true,
      disableEscapeKeyDownClose: true,
      dialogContent: (
        <PannaInterviewReportView
          data={e}
          currentInterview
          onSave={onUpdateInterviewStatus}
          sendEmail={sendEmail}
        />
      ),
    });
  };
  return (
    <div className="py-2">
      <CurrentInterviewsFilters
        onSubmit={onApplyFilter}
        onReset={onFiltersReset}
        currentInterview
      />
      <Paper className="mb-4 flex items-center justify-center mt-2 default-shadow-table overflow-x-auto">
        <Table
          loading={currentInterviewsFetching}
          data={convertApiDataToTable(currentInterviews)}
          onRowHover={onRowHover}
          columns={columns}
          title="Current Interviews"
          onChangePagination={onChangePagination}
          manualPagination={filters.pagination}
          pageSize={20}
          onRowClick={onRowClick}
        />
      </Paper>
    </div>
  );
}

export default Desktop;
